var MARK = 'v1';

export { MARK };
